<template>
    <div class="mcontent">
        <layout type="L_R"
         v-if="root.device!='phone'"
         :class="[root.device=='ipad'&&'mipad']"
        >
        <layout type="T_B">
          <wrapper>
              <cusbox txt="小组当天">
                  <itemlist
                      :count='5'
                      :columns='columns1'
                      :data='data1'
                  />
                  <!-- columnbg="#03083A" -->
              </cusbox>
          </wrapper>
          <wrapper>
              <cusbox txt="车间当天" >
                  <itemlist
                      :count='5'
                      :columns='columns2'
                      :data='data2'
                  />
              </cusbox>
          </wrapper>
      </layout>
            <layout type="T_B">
                <wrapper>
                    <cusbox txt="小组本月">
                        <itemlist
                            :count='5'
                            :columns='columns1'
                            :data='data1'
                        />
                    </cusbox>
                </wrapper>
                <wrapper>
                    <cusbox txt="车间本月" >
                        <itemlist
                            :count='5'
                            :columns='columns2'
                            :data='data2'
                        />
                    </cusbox>
                </wrapper>
            </layout>
        </layout>

         <mobile class="device_phone ppd notransform" v-else>
                 <div class="moblieline">
                  <cusbox txt="小组当天">
                    <itemlist
                        :count='5'
                        :columns='columns1'
                        :data='data1'
                    />
                </cusbox>
                </div>
                <div class="moblieline">
                  <cusbox txt="车间当天" >
                    <itemlist
                        :count='5'
                        :columns='columns2'
                        :data='data2'
                    />
                </cusbox>
                </div>
                <div class="moblieline">
                  <cusbox txt="小组本月">
                    <itemlist
                        :count='5'
                        :columns='columns1'
                        :data='data1'
                    />
                </cusbox>
                </div>
                <div class="moblieline">
                  <cusbox txt="车间本月" >
                    <itemlist
                        :count='5'
                        :columns='columns2'
                        :data='data2'
                    />
                </cusbox>
                </div>
         </mobile>
    </div>
</template>
<script>
import layout from "@/components/cuscom/layout.vue";
import wrapper from "@/components/cuscom/wrapper.vue";
import cusbox from "@/components/vip/cusbox";
import char2 from "./report/char2";
import char3 from "./report/char3";
import cchar2 from "../common/report/char2";
import custitle from "@/components/vip/custitle";
import cell from "@/components/cuscom/cell.vue";
import itemlist from "@/components/cuscom/itemlist"
import {cols_1,cols_2} from "./device/phone_column.js"
export default {
  components: {
    layout,
    cusbox,
    wrapper,
    char2,
    char3,
    cchar2,
    custitle,
    cell,
    itemlist,
  },
     inject:['root'],
  data() {
    return {
      cols_1,
      char2data: [
        {
          value: 2,
          name: "已完成",
          itemStyle: { color: "#4346D3" },
          showvalue: "110s"
        },
        {
          value: 3,
          name: "未完成",
          itemStyle: { color: "#2D99FF" },
          showvalue: "110s"
        },
      ],
      char2data2: [
        {
          value: 2,
          name: "检验",
          itemStyle: { color: "#4346D3" },
          showvalue: "110s"
        },
        {
          value: 3,
          name: "剪裁",
          itemStyle: { color: "#2D99FF" },
          showvalue: "110s"
        }, {
          value: 3,
          name: "车缝",
          itemStyle: { color: "#4346D3" },
          showvalue: "19s"
        },
         {
          value: 3,
          name: "包装",
          itemStyle: { color: "#2D99FF" },
          showvalue: "30s"
        },
        {
          value: 3,
          name: "后整",
          itemStyle: { color: "#4346D3" },
          showvalue: "118s"
        },
        {
          value: 3,
          name: "工艺",
          itemStyle: { color: "#2D99FF" },
          showvalue: "220s"
        },
      ],
      char2data3: [
        {
          value: 2,
          name: "检验",
          itemStyle: { color: "#4346D3" },
          showvalue: "10人"
        },
        {
          value: 3,
          name: "剪裁",
          itemStyle: { color: "#2D99FF" },
          showvalue: "20人"
        }, {
          value: 3,
          name: "车缝",
          itemStyle: { color: "#4346D3" },
          showvalue: "40人"
        },
         {
          value: 3,
          name: "包装",
          itemStyle: { color: "#2D99FF" },
          showvalue: "5人"
        },
        {
          value: 3,
          name: "后整",
          itemStyle: { color: "#4346D3" },
          showvalue: "10人"
        },
        {
          value: 3,
          name: "工艺",
          itemStyle: { color: "#2D99FF" },
          showvalue: "5人"
        },
      ],
      columns1: [
        {
          title: "排名",
          key: "number",
          align: "center",
           width:'2.5vw',
         
        },
        {
          title: "姓名",
          key: "name",
          align: "center"
        },
        {
          title: "线组/车间",
          key: "thread",
          align: "center",
           width:'6vw',
        },
        {
          title: "岗位",
          key: "post",
          align: "center"
        },
        // {
        //   title: "标准工时 s",
        //   key: "standard",
        //   align: "center"
        // },
        // {
        //   title: "实际工时 s",
        //   key: "actual",
        //   align: "center"
        // },
        {
          title: "效率",
          key: "efficiency",
          align: "center"
        }
      ],
       columns2: [
        {
          title: "排名",
          key: "number",
          align: "center",
         
        },
        {
          title: "姓名",
          key: "name",
          align: "center"
        },
        {
          title: "线组/车间",
          key: "thread",
          align: "center"
        },
        {
          title: "岗位",
          key: "post",
          align: "center"
        },
        {
          title: "产能（件）",
          key: "capacity",
          align: "center"
        },
        {
          title: "上月排名",
          key: "ranking",
          align: "center"
        },
      
      ],
      data1: [],
      data2: [],
      char1_data:{},
      datelist:[],
      cchar2_data:{},
      datelist2:[],
      char3_data:{},
      datelist3:[],
      api:this.$apis["capacity"]
    };
  },
 
  created(){
    console.log("nmsl");
  },
    mounted(){
        this.data1=[{
          number: 1,
          name: "王晓哲1",
          thread: "生产101组",
          post: "车缝",
          standard: 210,
          actual: 190,
          efficiency: "140%"
        },{
          number: 2,
          name: "王晓哲2",
          thread: "生产101组",
          post: "车缝",
          standard: 210,
          actual: 190,
          efficiency: "140%"
        },{
          number: 3,
          name: "王晓哲3",
          thread: "生产101组",
          post: "车缝",
          standard: 210,
          actual: 190,
          efficiency: "140%"
        },{
          number: 4,
          name: "王晓哲4",
          thread: "生产101组",
          post: "车缝",
          standard: 210,
          actual: 190,
          efficiency: "140%"
        },{
          number: 5,
          name: "王晓哲5",
          thread: "生产101组",
          post: "车缝",
          standard: 210,
          actual: 190,
          efficiency: "140%"
        },{
          number: 6,
          name: "王晓哲6",
          thread: "生产101组",
          post: "车缝",
          standard: 210,
          actual: 190,
          efficiency: "140%"
        }]

        this.data2=[{
            number:1,
            name:"蒋国一",
            thread:"生产104组",
            post:"车缝",
            capacity:2110,
            ranking:2
        },{
            number:2,
            name:"蒋国一2",
            thread:"生产104组",
            post:"车缝",
            capacity:2110,
            ranking:2
        },{
            number:3,
            name:"蒋国一3",
            thread:"生产104组",
            post:"车缝",
            capacity:2110,
            ranking:2
        },{
            number:4,
            name:"蒋国一4",
            thread:"生产104组",
            post:"车缝",
            capacity:2110,
            ranking:2
        },{
            number:5,
            name:"蒋国一5",
            thread:"生产104组",
            post:"车缝",
            capacity:2110,
            ranking:2
        },{
            number:6,
            name:"蒋国一6",
            thread:"生产104组",
            post:"车缝",
            capacity:2110,
            ranking:2
        }]

        // this.api.get1().then(res=>{       
        //             var obj={orders:[],date:[],overdue:[],rate:[],sale:[]}
        //             for(var i=0;i<res.data.list.length;i++){
        //                 obj.orders.push(res.data.list[i].orders)
        //                 obj.date.push(res.data.list[i].date)
        //                 obj.overdue.push(res.data.list[i].overdue)
        //                 obj.rate.push(res.data.list[i].rate)
        //                 obj.sale.push(res.data.list[i].sale)
        //             }
        //             this.char1_data=obj
        //             this.datelist=obj.date
        // }) 
        // this.api.get2().then(res=>{       
        //   var obj={date:[],saleTotal:[]}
        //   for(var i=0;i<res.data.list.length;i++){
        //     obj.date.push(res.data.list[i].date)
        //     obj.saleTotal.push(res.data.list[i].saleTotal)
        //   }
        //   this.cchar2_data=obj
        //   this.datelist2=obj.date
        // })
        // this.api.get3().then(res=>{        
        //   var obj={name:[],actual:[],average:[]}
        //   for(var i=0;i<res.data.list.length;i++){
        //     obj.name.push('员工'+i)
        //     obj.actual.push(res.data.list[i].actual)
        //     obj.average.push(res.data.list[i].average)
        //   }
        //   this.char3_data=obj
        //   this.datelist3=obj.name
        // })
    }
};
</script>
<style lang='scss'>
@import './device/phone.scss';
</style>
<style lang="scss" scoped>
.mipad{
   .more_device_txt1{
     font-size: 32px;
   }
   .more_device_txt2{
     .txt1{
       font-size: 24px !important;
     }
     .txt2{
       font-size: 40px;
       font-weight: bold;
     }    
   }
}
.mcontent {
  color: #fff;
  height: 100%;
  display: flex;
  .mytt {
    height: 30px;
  }
  .mtt {
    .txt1 {
      font-size: 12px;
      height: 30px;
    }                                                        
   .txt1 {
      font-size: 12px;
      height: 30px;
    }
    img {
      margin-right: 10px;
      width: 40px;
      height: 40px;
      display: block;
    }
  }
}


</style>